

module.exports = __webpack_require__.stylable.create(
    "o4",
    {"classes":{"root":"s0","digitflowLogo":"s1","stylableLogo":"s2","titleGroup":"s3","title":"s4"},"vars":{},"stVars":{},"keyframes":{"digitflowAnimation":"o4__digitflowAnimation"}},
    "",
    2,
    5,
    null
);

